import styled from 'styled-components'
import { theme } from '../../../../style/theme'
import { colorTheme } from '../../../../style/theme/colorTheme'

export const OrderButtonsWrap = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	gap: 0.63em;
	width: 100%;

	@media screen and (max-width: ${theme.point720}) {
		grid-template-columns: auto;
	}
`
OrderButtonsWrap.displayName = 'OrderButtonsWrap'

export const DenyButton = styled.button`
	font-size: 1em;
	display: flex;
	align-items: center;
	justify-content: center;
	min-height: 3.44em;
	padding: 0.63em 1em;
	border-radius: 0.75em;
	border: 2px solid ${colorTheme.denyOrderModal.button.border};
	background-color: ${colorTheme.denyOrderModal.button.background};
	user-select: none;
	cursor: pointer;

	&.active {
		background-color: ${colorTheme.denyOrderModal.button.active.background};
		border-color: ${colorTheme.denyOrderModal.button.active.border};
	}

	&.disabled {
		background-color: ${colorTheme.denyOrderModal.button.disabled.background};
		border-color: ${colorTheme.denyOrderModal.button.disabled.border};
	}
`
DenyButton.displayName = 'DenyButton'

export const DenyButtonText = styled.div`
	font-family: ${theme.fontRobotoMedium};
	font-size: 1.25em;
	font-weight: 500;
	color: ${colorTheme.denyOrderModal.button.text};

	&.active {
		color: ${colorTheme.denyOrderModal.button.active.text};
	}
`
DenyButtonText.displayName = 'DenyButtonText'
